'use client'

import Header from '@/components/header/Header'
import { useEffect } from 'react'
// import logoMain from '@/assets/img/logo-main.svg'
import logoMain from '@/assets/img/dark-vers.svg'
import Footer from '@/components/Footer/Footer'
import MainSceneWithWrapper from '@/components/MainSceneWithWrapper/MainSceneWithWrapper'
import { B2BFeatures } from '@/components/b2b/B2BFeatures'
import { B2BIntro } from '@/components/b2b/B2BIntro'
import { B2BMedia } from '@/components/b2b/B2BMedia'
import { B2BToday } from '@/components/b2b/B2BToday'
import { setFooterTab, setResetCatalogFilters, setResetMaterialsFilters, setResetNewsFilters } from '@/redux/features/filterSlice'
import { useDispatch } from 'react-redux'

const B2BModule = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setResetNewsFilters())
        dispatch(setResetMaterialsFilters())
        dispatch(setResetCatalogFilters())
        dispatch(setFooterTab(1))
    }, [])

    return (
        <main className='main b2b'>
            <Header
                burgerBg='linear-gradient(180deg, #3156A8 21.87%, #2D3079 108.55%)'
            />

            <MainSceneWithWrapper
                top={0}
                zInx={2}
            />
            <div className='container b2b__top'>
                <B2BIntro />
                <B2BToday />
            </div>
            <B2BMedia />
            <div className='container'>
                <B2BFeatures />
            </div>
            <Footer />
        </main>
    )
}

export default B2BModule
